<template>
  <span class="file-thumbnail-show-wrapper">
    <a :href="item.url ? item.url : 'javascript:void(0);'" :key="index" :target="item.url ? '_blank' : '_self'" class="file-thumbnail-item c-gray" v-for="(item, index) in filterList">
      <img :src="item.image_url" style="width: 40px; height: 48px" />
      <p class="file-thumbnail-item-title">{{ item.file_name }}</p>
      <div class="file-thumbnail-delete" v-if="manage">
        <i @click.stop.prevent="remove(item)" class="iconfont iconclose remove-icon"></i>
      </div>
    </a>
  </span>
</template>

<script>
import { findFileImage } from '@Utils/business'
export default {
  emits: ['on-remove'],
  props: ['list', 'manage'],
  data() {
    return {}
  },
  computed: {
    filterList() {
      return this.list.map(item => {
        item.image_url = findFileImage(item.file_name)
        return item
      })
    }
  },
  methods: {
    remove(value) {
      this.$emit('on-remove', value)
    }
  }
}
</script>

<style lang="less">
.file-thumbnail-show-wrapper {
  vertical-align: middle;

  .file-thumbnail-item {
    position: relative;
    display: inline-block;
    height: 90px;
    width: 120px;
    border: 1px solid #dadae1;
    border-radius: 2px;
    margin-right: 12px;
    margin-bottom: 8px;
    padding: 10px;
    vertical-align: middle;
    text-align: center;
    line-height: 0;
    cursor: pointer;
  }

  .file-thumbnail-item-title {
    white-space: nowrap;
    word-break: break-all;
    text-overflow: ellipsis;
    overflow: hidden;
    line-height: 28px;
    color: #333333;
  }

  .file-thumbnail-delete {
    position: absolute;
    top: 12px;
    right: 4px;
    display: none;
    cursor: pointer;
  }

  .file-thumbnail-item:hover .file-thumbnail-delete {
    display: block;
  }

  .remove-icon {
    font-size: 14px !important;
    background-color: #8d9099;
    border-radius: 8px;
    padding: 1px;
    color: #ffffff;
  }

  .ivu-form-item-content {
    line-height: 20px !important;
  }
}
</style>
